<template>
  <div class="onboarding-card text-center">
    <img src="/images/onboarding/logo-terrazon.svg" alt="Terrazon" class="ob-logo-img" />

    <div class="ob-icon-wrap my-4">
      <img src="/images/onboarding/icono-bienvenida.svg" alt="" class="ob-icon-img" />
    </div>

    <p class="ob-text">Ingresa y llena la información requerida</p>

    <button type="button" class="btn ob-btn-primary w-100 mt-4" @click="$emit('comenzar')">
      COMENZAR
    </button>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
export default {
  name: 'PantallaBienvenida',
};
</script>
